if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.modalArrows = this.querySelector("#product-media-modal--arrows");
        this.counter = this.querySelector("#product-media-modal--arrows span");
        this.totalItems = this.querySelector(
          ".product-media-modal__content",
        ).childElementCount;
        this.counter.innerHTML = `1/${this.totalItems}`;
        this.modalArrows.addEventListener(
          "click",
          this.modalArrowsEventHandler.bind(this),
        );
        this.querySelector('[role="document"]').addEventListener(
          "scroll",
          this.handleScroll.bind(this),
        );
        this.addEventListener("click", this.handleClickEvent.bind(this));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id",
          )}"])`,
        ).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`,
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft =
          activeMedia.offsetLeft -
          container.clientWidth / 2 +
          activeMedia.clientWidth / 2;

        this.setActiveIndex(activeMedia.dataset.forloopIndex);
        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }

      modalArrowsEventHandler(event) {
        const btn = event.target.closest("button.product-media-modal--arrow");
        if (!btn) return;
        const { arrowAction } = btn.dataset;
        const activeSlide = this.querySelector(".global-media-settings.active");
        let activeIndex = parseInt(activeSlide.dataset.forloopIndex);
        let newActiveIndex =
          arrowAction === "next" ? activeIndex + 1 : activeIndex - 1;
        const newActiveSlide = this.querySelector(
          `.global-media-settings[data-forloop-index="${newActiveIndex}"]`,
        );
        if (!newActiveSlide) return;
        activeSlide.classList.remove("active");
        newActiveSlide.classList.add("active");
        newActiveSlide.scrollIntoView({ behavior: "smooth", inline: "center" });
      }

      handleScroll() {
        const container = this.querySelector('[role="document"]');
        const slides = this.querySelectorAll(".global-media-settings");

        let closestSlide = null;
        let closestDistance = Infinity;

        slides.forEach((slide) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const containerCenter =
            container.scrollLeft + container.offsetWidth / 2;
          const distance = Math.abs(containerCenter - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestSlide = slide;
          }
        });

        if (closestSlide && !closestSlide.classList.contains("active")) {
          this.querySelector(".global-media-settings.active")?.classList.remove(
            "active",
          );
          closestSlide.classList.add("active");
          this.setActiveIndex(closestSlide.dataset.forloopIndex);
        }
      }

      setActiveIndex(index) {
        this.counter.innerHTML = `${parseInt(index)}/${this.totalItems}`;
      }

      handleClickEvent(event) {
        // Close only when the click lands OUTSIDE the dialog (i.e. on the modal
        // backdrop). Clicking inside the dialog — including on a video's poster /
        // cover frame — must not close the modal, otherwise the poster click
        // never reaches the deferred-media element that plays the video.
        if (!event.target.closest(".product-media-modal__dialog")) {
          this.hide();
        }
      }
    },
  );
}
